<template>
  <div style="margin: 15px 0 0 0; align-items: flex-start; justify-content:flex-start; width: 245px; flex-direction:column;" class="flex-centered">
    <table class="sidemenus" style="margin-left:20px;">
      <th style="border-bottom:1px solid black;">
        
        <td style="font-size: 13px" align="center">
          Etapas Planejar
        </td>
      </th>
      <tr>
        <td v-if="$store.state.step == 1" @click="$store.state.step = 1, $store.state.chegouStepQuatro = false" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 1}">Nova simulação</td>
      </tr>
      <tr>
        <td v-if="$store.state.step >= 2" @click="$store.state.step = 2, $store.state.chegouStepQuatro = false" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 2 || $store.state.step == 3}">Atividades</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 1, $store.state.chegouMonthStepQuatro = false" v-if="$store.state.chegouStepQuatro == true" style="cursor:pointer; padding-top: 14px;" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 1 || $store.state.monthstep == 2 || $store.state.monthstep == 3 || $store.state.monthstep == 4}">Receita Bruta</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 5" v-if="$store.state.chegouStepQuatro == true && $store.state.chegouMonthStepQuatro == true" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 5 || $store.state.monthstep == 6}">Deduções da Receita Bruta</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 7" v-if="$store.state.chegouStepQuatro == true && $store.state.chegouMonthStepQuatro == true" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 7}">Custos e Despesas da Atividade em Geral</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 8" v-if="$store.state.chegouStepQuatro == true && $store.state.chegouMonthStepQuatro == true" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 8}">Demais Custos de Produção</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 9" v-if="$store.state.step >= 4 && $store.state.monthstep >= 4" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 9}">Folha de Pagamentos e Encargos</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 10" v-if="$store.state.step >= 4 && $store.state.monthstep >= 4" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 10 || $store.state.monthstep == 11 || $store.state.monthstep == 12}">Despesas Operacionais Gerais</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 4, $store.state.monthstep = 13" v-if="$store.state.step >= 4 && $store.state.monthstep >= 4" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step == 4 && $store.state.monthstep == 13 || $store.state.monthstep == 14}">Outras Receitas Operacionais</td>
      </tr>
      <tr>
        <td @click="$store.state.step = 5, $store.state.totalresultstep = 1" v-if="$store.state.step >= 5" style="cursor:pointer" class="td-bar" :class="{'active-td' : $store.state.step >= 5 && $store.state.totalresultstep == 1}">Resultado Comparativo</td>
      </tr>
    </table>
    <!-- <table class="sidemenus" v-if="$store.state.step == 5" style="margin-left:20px; margin-top:40px">
      <th style="width:100%; border-bottom:1px solid rgb(0,0,0,0.10);">
      </th>
      <tr>
        <td style="cursor:pointer" class="td-bar" @click="$store.state.totalresultstep = 3" :class="{'active-td' : false}">Resultado Completo</td>
      </tr> -->
      <!-- <tr>
        <td style="cursor:pointer" class="td-bar" @click="$store.state.totalresultstep = 2, $store.state.resultstep = 1" :class="{'active-td' : $store.state.step == 5 && $store.state.totalresultstep == 2 && $store.state.resultstep == 1}">Simples Nacional</td>
      </tr>
      <tr>
        <td style="cursor:pointer" class="td-bar" @click="$store.state.totalresultstep = 2, $store.state.resultstep = 2" :class="{'active-td' : $store.state.step == 5 && $store.state.totalresultstep == 2 && $store.state.resultstep == 2}">Lucro Presumido</td>
      </tr>
      <tr>
        <td style="cursor:pointer" class="td-bar" @click="$store.state.totalresultstep = 2, $store.state.resultstep = 3" :class="{'active-td' : $store.state.step == 5 && $store.state.totalresultstep == 2 && $store.state.resultstep == 3}">Lucro Real (Trimestral)</td>
      </tr>
      <tr>
        <td style="cursor:pointer" class="td-bar" @click="$store.state.totalresultstep = 2, $store.state.resultstep = 4" :class="{'active-td' : $store.state.step == 5 && $store.state.totalresultstep == 2 && $store.state.resultstep == 4}">Lucro Real (Anual)</td>
      </tr> -->
    <!-- </table> -->
    
  </div>
</template>

<script>

import api from "../../services/api";
export default {
  data() {
    return {
       menu: [
                    {
                        header: true,
                        title: 'Main Navigation',
                        hiddenOnCollapse: true
                    },
                    {
                        href: '/',
                        title: 'Dashboardddddddddddddddd',
                        icon: 'fa fa-user'
                    },
                    {
                        href: '/charts',
                        title: 'Charts',
                        icon: 'fa fa-chart-area',
                        child: [
                            {
                                href: '/charts/sublink',
                                title: 'Sub Link'
                            }
                        ]
                    }
                ]
    };
  },
  props: ["view"],
  methods: {},
};
</script>

<style>
.td-bar-second {
  font-size: 10px;
}

.td-bar {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.td-bar:hover {
  transition: 0.6s ease;
  transform: scale(1.01);
}

.active-td {
  transform: scaleX(1);
  border-left: 3px solid #af3437;
}

.sidemenus tr {
  font-size: 12px;
  font-weight: 600;
}

.sidemenus td {
  padding: 2.5px 0 !important;
  padding-left: 5px !important;
}

.unselectable {
  cursor: not-allowed;
}
</style>